import _flowRight from 'lodash/flowRight';
import _uniqueId from 'lodash/uniqueId';
import { normalize } from 'normalizr';
import { getPRWorkOrders } from '@homeservices/api-kit/workorder/proreferral';

import { WORK_ORDERS_SCHEMA } from '@/store/modules/entities';
import { toSnakeCase } from '@/utils/to-snake-case';
import {
  withRequestLifecycle,
  REQUEST_LIFECYCLE,
} from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchWorkOrders';

const emptyArray = [];

const initialPartialState = {
  status: REQUEST_LIFECYCLE.UNINITIALIZED,
  error: null,
  result: emptyArray,
  count: 0,
  total: 0,
  hasMore: false,
};

export default {
  namespaced: true,
  state: {
    workOrdersKey: _uniqueId(),
  },
  getters: {
    workOrdersKey: state => state.workOrdersKey,
    getWorkOrdersMetaByBucketName: state => (bucketName) => {
      const { result, ...meta } = state[bucketName] || initialPartialState;

      return meta;
    },
    getRawWorkOrdersByBucketName: state => bucketName =>
      (state[bucketName] || initialPartialState).result,
  },
  actions: {
    fetchWorkOrders: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (
        { dispatch },
        { injected: { performFulfillment, performSideEffect },
          includePublicProfiles,
          params = {},
        }) => {
        const {
          data: { results, total },
        } = await getPRWorkOrders(toSnakeCase(params));
        const { result, entities } = normalize(results, [WORK_ORDERS_SCHEMA]);

        if (includePublicProfiles) {
          performSideEffect(() =>
            dispatch(
              'dashboard/publicProfiles/fetchPublicProfiles',
              {
                bucketName: 'workOrders',
                params: {
                  service_provider_identifiers: Object.values(entities.matches).map(
                    ({ service_provider_user_identifier }) => service_provider_user_identifier
                  ).join(','),
                  size: 100,
                },
              },
              { root: true }
            )
          );
        }

        return performFulfillment({
          total,
          result,
          entities,
        });
      }
    ),
    resetWorkOrders: ({ commit }, { bucketName }) =>
      commit('resetWorkOrders', { meta: { bucketName } }),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { bucketName } = payload.meta;
      const partialState = state[bucketName] || initialPartialState;
      const result = [
        ...new Set([...partialState.result, ...(payload.result || emptyArray)]),
      ];

      state[bucketName] = {
        ...partialState,
        ...payload,
        result,
        count: result.length,
        hasMore: result.length < payload.total,
      };

      state.workOrdersKey = _uniqueId();
    },
    resetWorkOrders (state, { meta }) {
      const { bucketName } = meta;

      state[bucketName] = initialPartialState;
      state[bucketName].meta = meta;

      state.workOrdersKey = _uniqueId();
    },
  },
};
